import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type DeleteLiquidacionProformaResponse = {
  value: boolean;
};

type DeleteLiquidacionProformaParams = {
  oidVisita: number;
};

export const deleteLiquidacionProforma = async (
  query: DeleteLiquidacionProformaParams
): Promise<DeleteLiquidacionProformaResponse['value']> => {
  try {
    const res = await apiClient.post<DeleteLiquidacionProformaResponse>(
      Endpoints.DeleteLiquidacionProforma,
      query
    );

    return res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
